// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-container-eawV5 {
  height: 100%;
  padding-left: 20px;
  overflow: hidden;
}

.users-table_container-RnqSW {
  overflow: scroll;
  padding-right: 10px;
}

.users-addUser_base-zZhnG {
  width: fit-content;
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/users/users.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".container {\n  height: 100%;\n  padding-left: 20px;\n  overflow: hidden;\n}\n\n.table_container {\n  overflow: scroll;\n  padding-right: 10px;\n}\n\n.addUser_base {\n  width: fit-content;\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `users-container-eawV5`,
	"table_container": `users-table_container-RnqSW`,
	"addUser_base": `users-addUser_base-zZhnG`
};
export default ___CSS_LOADER_EXPORT___;
